<div class="terms-container">
  <h1 class="title">Terms and Conditions</h1>
  <p class="last-updated">Sharani Ponguru</p>

  <section>
    <p>This agreement applies as between you, the User of this Website, and Sharani Ponguru, the owner and founder of The Mindset Movement. Your agreement to comply with and be bound by these Terms and Conditions is deemed to occur upon your first use of the Website. If you do not agree to be bound by these Terms and Conditions, you should stop using the Website immediately.</p>
    <p>No part of this Website is intended to constitute a contractual offer capable of acceptance. Your order constitutes a contractual offer, and our acceptance of that offer is deemed to occur upon our sending a dispatch email to you indicating that your order has been fulfilled and is on its way.</p>
  </section>

  <section>
    <h2>Definitions and Interpretation</h2>
    <p>In this Agreement, the following terms shall have the following meanings:</p>
    <table>
      <tr>
        <th>Term</th>
        <th>Definition</th>
      </tr>
      <tr>
        <td>"Account"</td>
        <td>Personal information, Payment Information, and credentials used by Users to access Paid Content or communication systems on the Website.</td>
      </tr>
      <tr>
        <td>"Carrier"</td>
        <td>Third-party responsible for delivering physical Goods.</td>
      </tr>
      <tr>
        <td>"Content"</td>
        <td>Any media, text, images, data, or interactive features on the Website.</td>
      </tr>
      <tr>
        <td>"Goods"</td>
        <td>Products offered by Sharani Ponguru for purchase, such as books, journals, or merchandise.</td>
      </tr>
      <tr>
        <td>"Service"</td>
        <td>Online tools, learning systems, coaching programs, and related content.</td>
      </tr>
      <tr>
        <td>"Payment Information"</td>
        <td>Details required for purchases including card/bank info.</td>
      </tr>
      <tr>
        <td>"Purchase Information"</td>
        <td>Includes receipts, dispatch notes, invoices, or order confirmations.</td>
      </tr>
      <tr>
        <td>"Premises"</td>
        <td>Our operational and delivery address (where applicable).</td>
      </tr>
      <tr>
        <td>"System"</td>
        <td>Online infrastructure like chat, email, WhatsApp, or integrated support.</td>
      </tr>
      <tr>
        <td>"User"</td>
        <td>Anyone accessing the Website not employed by The Mindset Movement.</td>
      </tr>
      <tr>
        <td>"Website"</td>
        <td>The site you're currently using: www.sharaniponguru.me</td>
      </tr>
    </table>
  </section>

  <section>
    <h2>Age Restrictions</h2>
    <p>Persons under 18 may only use this website with supervision and consent of a parent or guardian. Payment details must also be approved or submitted by the guardian.</p>
  </section>

  <section>
    <h2>Business & International Customers</h2>
    <p>These Terms and Conditions also apply to international and business customers. Orders placed from outside India may be subject to import duties and taxes. These are the responsibility of the User and not calculated by Sharani Ponguru or her team. Contact your customs office for details.</p>
  </section>

  <section>
    <h2>Intellectual Property</h2>
    <p>All content on the Website, unless uploaded by Users, is owned by Sharani Ponguru and is protected by applicable copyright laws. You may not reuse, distribute, or copy any content without express written permission.</p>
    <p>Third-party logos, images, or trademarks belong to respective owners.</p>
  </section>

  <section>
    <h2>Links to Other Websites</h2>
    <p>This Website may contain links to external websites. We are not responsible for their content, security, or policies. Use them at your discretion.</p>
  </section>

  <section>
    <h2>Linking to Our Website</h2>
    <p>You may link to www.sharaniponguru.me only to the homepage unless written permission is granted to deep-link specific pages.</p>
  </section>

  <section>
    <h2>Use of Communication Systems</h2>
    <p>When using forms, live chat, email links, or WhatsApp integrations:</p>
    <ul>
      <li>Do not use vulgar, defamatory, or illegal language.</li>
      <li>Do not impersonate others.</li>
      <li>Spam or mass marketing is prohibited.</li>
      <li>We reserve the right to monitor or moderate communication on our platforms.</li>
    </ul>
  </section>

  <section>
    <h2>Accounts</h2>
    <p>To access certain features, you may be required to create an account. You must provide accurate and truthful information and keep your login details secure. We do not accept responsibility for unauthorized use of your account.</p>
  </section>

  <section>
    <h2>Termination & Cancellation</h2>
    <p>We may terminate user accounts at our discretion. In such cases, any pending purchases will still be fulfilled unless otherwise stated.</p>
    <p>You may cancel your account at any time by contacting thesharaniponguru@gmail.com. Refunds, where applicable, will follow our refund policy.</p>
  </section>

  <section>
    <h2>Goods, Pricing & Availability</h2>
    <ul>
      <li>Product representations are accurate but may vary slightly.</li>
      <li>Prices are updated regularly and are subject to change.</li>
      <li>Shipping charges may apply.</li>
      <li>Goods are subject to availability.</li>
    </ul>
  </section>

  <section>
    <h2>Delivery</h2>
    <p>Shipping notifications and delivery updates will be sent via email or WhatsApp. If no issues are reported within 7 days of receipt, the goods are considered delivered in good condition.</p>
  </section>

  <section>
    <h2>Returns Policy</h2>
    <p>We aim to provide only high-quality Goods. If your order is incorrect, damaged, or defective:</p>
    <ul>
      <li>Contact us within 7 days at thesharaniponguru@gmail.com</li>
      <li>Goods must be returned in original packaging.</li>
      <li>Refunds/replacements are processed after we receive the returned goods.</li>
      <li>Certain items like opened audio/video products or digital downloads are non-refundable.</li>
    </ul>
  </section>

  <section>
    <h2>Events, Sessions, and Coaching</h2>
    <p>Tickets for live sessions are refundable within 7 days of purchase. After that, they are non-refundable but transferable. Sharani may also promote external events. Refund policies for those may differ.</p>
  </section>

  <section>
    <h2>Privacy</h2>
    <p>We take your privacy seriously. Your personal data is never sold or misused. Read the full Privacy Policy on our website.</p>
  </section>

  <section>
    <h2>Disclaimers</h2>
    <p>The website is provided "as is." We make no guarantee of specific outcomes from using our services, tools, or programs.</p>
    <p>Content is for general information and should not be taken as legal, medical, or psychological advice.</p>
  </section>

  <section>
    <h2>Changes to Terms</h2>
    <p>We reserve the right to update these terms. Continued use after changes indicates acceptance.</p>
  </section>

  <section>
    <h2>Availability</h2>
    <p>We strive to maintain uninterrupted access, but service may occasionally be unavailable due to maintenance, server issues, or external disruptions.</p>
  </section>

  <section>
    <h2>Limitation of Liability</h2>
    <p>To the maximum extent permitted by law, The Mindset Movement / Sharani Ponguru is not liable for:</p>
    <ul>
      <li>Any indirect, special, or consequential damages</li>
      <li>Loss of data, revenue, or opportunity from using the Website</li>
    </ul>
    <p>We remain liable for issues arising from fraud, death, or injury caused by our negligence.</p>
  </section>

  <section>
    <h2>Severability</h2>
    <p>If any clause in these Terms is found invalid by law, the rest remain enforceable.</p>
  </section>

  <section>
    <h2>Notices</h2>
    <p>All notices to us must be sent via email to:</p>
    <p>thesharaniponguru@gmail.com</p>
  </section>

  <section>
    <h2>Governing Law</h2>
    <p>These Terms shall be governed by the laws of India. Any disputes shall fall under the jurisdiction of Indian courts.</p>
  </section>
</div>